export const RESTRICTED_CHARACTERS_REG_EXP = new RegExp(/[^0-9A-Za-zÀ-Ÿà-ÿ-'\s,.&/\\'"@?()\n]/);
